var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { $ } from 'hanako-ts/dist-legacy/Framework';
import { Component } from 'hanako-ts/dist-legacy/Component';
export class SingleTutorial extends Component {
    constructor() {
        super('SingleTutorial', false);
        this.currentStepIndex = 0;
    }
    init() {
        const _super = Object.create(null, {
            init: { get: () => super.init }
        });
        return __awaiter(this, void 0, void 0, function* () {
            yield _super.init.call(this);
            // Manage prefered platform tab
            this.managePreferedPlatform();
            // Build video navigation
            $('#platform-tabs-content .tab-pane').each((tabPane) => {
                this.buildVideoNavigation(tabPane);
            });
            $('.btn-start-tutorial').on('click', (event, button) => {
                event.preventDefault();
                $('#tutorial').addClass('is-started');
                $('.tab-pane.active .btn-toggle-play').trigger('click');
            });
            this.success();
        });
    }
    managePreferedPlatform() {
        // Save preferred platform in session storage
        $('[data-platform-selector] button').on('click', (event, button) => {
            event.preventDefault();
            const platform = button.data('platform');
            const platformCategory = ['ios', 'android'].includes(platform) ? 'mobile' : 'desktop';
            sessionStorage.setItem(`prefered_platform_${platformCategory}`, platform);
        });
        // On page load, activate preferred platform tab if any
        const tutorialType = $('[data-platform-selector]').data('platformType');
        const preferedType = sessionStorage.getItem(`prefered_platform_${tutorialType}`);
        if (preferedType) {
            $(`[data-platform-selector] button[data-platform="${preferedType}"]`).trigger('click');
            $('.platforms-text').addClass('d-none');
            $(`.platforms-text[data-platform="${preferedType}"]`).removeClass('d-none');
        }
    }
    buildVideoNavigation(tabPane) {
        return __awaiter(this, void 0, void 0, function* () {
            const videoElement = tabPane.find('.tutorial-video-video');
            const navigationLinks = tabPane.find('.tutorial-video-navigation a');
            // Await video metadata to be loaded
            yield new Promise((resolve) => {
                if (videoElement.get(0).readyState >= 1) {
                    resolve();
                }
                else {
                    videoElement.on('loadedmetadata', () => {
                        resolve();
                    });
                }
            });
            const videoDuration = videoElement.get(0).duration;
            navigationLinks.each((link) => {
                const start = parseInt(link.data('timecode'));
                const ending = link.next().length > 0 ? parseInt(link.next().data('timecode')) : videoDuration;
                const percentage = ((ending - start) / videoDuration) * 100;
                link.css('width', `calc(${percentage}% - 5px)`);
            });
            videoElement.on('timeupdate', () => {
                const currentTime = videoElement.get(0).currentTime;
                navigationLinks.each((link) => {
                    const start = parseInt(link.data('timecode'));
                    const ending = link.next().length > 0 ? parseInt(link.next().data('timecode')) : videoDuration;
                    if (currentTime > ending) {
                        link.addClass('completed');
                        tabPane.find('.step').eq(link.index()).removeClass('active');
                    }
                    else if (currentTime >= start && currentTime < ending) {
                        if (!link.hasClass('active')) {
                            this.currentStepIndex = link.index();
                            if ($(window).width() >= 992) {
                                tabPane.find('.tutorial-video-steps').get(0).scrollTo({
                                    top: tabPane.find('.step').eq(link.index()).position().y,
                                    behavior: 'smooth',
                                });
                            }
                        }
                        link.addClass('active').removeClass('completed');
                        tabPane.find('.step').eq(link.index()).addClass('active');
                        link.css('--progress', `${((currentTime - start) / (ending - start)) * 100}%`);
                    }
                    else {
                        link.removeClass('active completed');
                        tabPane.find('.step').eq(link.index()).removeClass('active completed');
                    }
                });
                if (this.currentStepIndex > 0) {
                    tabPane.find('.btn-prev').removeAttr('disabled');
                }
                else {
                    tabPane.find('.btn-prev').attr('disabled', 'disabled');
                }
                if (this.currentStepIndex == navigationLinks.length - 1) {
                    tabPane.find('.btn-next').attr('disabled', 'disabled');
                }
                else {
                    tabPane.find('.btn-next').removeAttr('disabled');
                }
            });
            videoElement.on('ended', () => {
                $('#tutorial').removeClass('is-started');
            });
            navigationLinks.on('click', (event, link) => {
                event.preventDefault();
                const timecode = parseInt(link.data('timecode'));
                videoElement.get(0).currentTime = timecode;
            });
            tabPane.find('.tutorial-video-video, .btn-toggle-play').on('click', () => {
                const videoElement = tabPane.find('.tutorial-video-video').get(0);
                videoElement.paused ? videoElement.play() : videoElement.pause();
            });
            tabPane.find('.btn-prev').on('click', () => {
                const videoElement = tabPane.find('.tutorial-video-video').get(0);
                if (this.currentStepIndex > 0) {
                    let newTimecode = 0;
                    const currentStepStartTimecode = parseInt(tabPane.find('.tutorial-video-navigation a').eq(this.currentStepIndex).data('timecode'));
                    if (videoElement.currentTime - currentStepStartTimecode > 1.5) {
                        newTimecode = currentStepStartTimecode;
                    }
                    else {
                        const previousLink = tabPane.find('.tutorial-video-navigation a').eq(this.currentStepIndex - 1);
                        newTimecode = parseInt(previousLink.data('timecode'));
                    }
                    videoElement.currentTime = newTimecode + 0.1;
                }
            });
            tabPane.find('.btn-next').on('click', () => {
                const videoElement = tabPane.find('.tutorial-video-video').get(0);
                const nextLink = tabPane.find('.tutorial-video-navigation a').eq(this.currentStepIndex + 1);
                if (nextLink.length > 0) {
                    const timecode = parseInt(nextLink.data('timecode'));
                    videoElement.currentTime = timecode;
                }
            });
            tabPane.find('.tutorial-video-video').on('play', () => {
                tabPane.find('.btn-toggle-play').data('status', 'pause');
                tabPane.find('.btn-prev, .btn-next').removeAttr('disabled');
            });
            tabPane.find('.tutorial-video-video').on(['pause', 'ended'], () => {
                tabPane.find('.btn-toggle-play').data('status', 'play');
                tabPane.find('.btn-prev, .btn-next').attr('disabled', 'disabled');
            });
        });
    }
}
